import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../../assets/images/logo.png";

const Buycredit = ({
  show,
  onClose,
  data = {},
  communicationType = "chat",
  expert,
  credits,
}) => {
  const [languageData, setLanguageData] = useState(null);
  const safeCredits = Number(credits ?? 0);
  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../../lang/no-credit/${cookieLang}.json`)
        .then((res) => setLanguageData(res))
        .catch((err) => console.error("Error loading language file:", err));
    }
  }, []);

  if (!languageData) return null;

  const handleButtonClick = () => {
    window.location.href = "/portal/plans";
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      dialogClassName="custom-modal-dialog"
      centered
    >
      <Modal.Header closeButton className="modal-header-gradient">
        <img 
          src={logo}
          alt="Logo"
          style={{ height: "12px", marginRight: "auto" }}
        />
      </Modal.Header>

      <Modal.Body className="p-0">
        <div className="d-flex align-items-center justify-content-center p-3 body-section-gradient">
          <div className="position-relative me-2">
            <img
              src={expert?.image}
              alt={expert?.nickname}
              className="rounded-circle profile-image"
            />
            <span
              className={`position-absolute status-indicator ${
                expert?.status === "available"
                  ? "status-available"
                  : "status-unavailable"
              }`}
            />
          </div>

          <div>
            <p className="mb-0 consultant-header">
              {languageData.header.title}
            </p>
            <p className="mb-0 consultant-name">
              {expert?.nickname ? expert.nickname.toUpperCase() : ""}
            </p>
          </div>
        </div>
        <div className="flex flex-column gap-1r flex justify-content-center align-items-center p-35">
          <div className="alert alert-warning alertWarning">
            {languageData.content["subtitle"]}
          </div>

          <div className="mb-3 credit">
            <b> {languageData.content.credit}</b> {safeCredits} {languageData.content.credits}
          </div>

          <p className="descriptionCredit">
            {languageData.content["description"]} {data?.nickname || ""}
          </p>

          <button className="btn btn-danger" onClick={handleButtonClick} data-interaction="buy_credit_modal_button">
            {languageData.content["button"]}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Buycredit;
